// Build an absolute URL to an auth-protected backend media file (profile images, etc.),
// appending the JWT as a ?token= query param.
//
// A plain <img src> or top-level browser navigation can't attach an Authorization header, so
// hitting an auth-required GET that way returns 401 and the image never loads. The backend's
// JWT filter accepts the token via a ?token= query param on GET requests — the same approach the
// Patient/User document views use — so we append it here.
const HOST = (process.env.REACT_APP_API_URL || 'http://localhost:8080/api').replace('/api', '');

export const authedMediaUrl = (urlOrPath) => {
  if (!urlOrPath) return null;
  const base = urlOrPath.startsWith('http') ? urlOrPath : `${HOST}${urlOrPath}`;
  const token = localStorage.getItem('clinic_auth_token');
  if (!token) return base;
  return `${base}${base.includes('?') ? '&' : '?'}token=${encodeURIComponent(token)}`;
};
